import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearchText',
  standalone: true,
})
export class HighlightSearchTextPipe implements PipeTransform {
  transform(value: string | null | undefined, search: string | null | undefined): string {
    if (!value) return '';
    if (!search?.trim()) return value;

    const escapedSearch = search.replace(/[-[\]{}()*+?.,\\^$|#]/g, '\\$&');

    const words = escapedSearch.split(/\s+/).filter((word) => word.length > 0);

    if (words.length === 0) return value;

    const pattern = words.join('|');

    const regex = new RegExp(pattern, 'gi');

    // Wrap matches in <b> tags
    return value.replace(regex, (match) => `<b>${match}</b>`);
  }
}
